import React, { useEffect, useState } from "react";
import { add, differenceInSeconds, formatDuration } from "date-fns";

function pad(num, size) {
  num = num.toString();
  while (num.length < size) num = "0" + num;
  return num;
}

const formatDifference = (difference) => {
  const minutes = Math.floor(difference / 60);
  const seconds = pad(difference % 60, 2);
  return [minutes, seconds].join(":");
};

const Timer = ({ children, start, duration }) => {
  const end = add(start, {
    seconds: duration,
  });
  const [difference, setDifference] = useState(
    differenceInSeconds(end, new Date())
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setDifference(differenceInSeconds(end, new Date()));
    }, 1000);

    return () => {
      window.clearInterval(interval);
    };
  }, []);

  return children({ difference, formatted: formatDifference(difference) });

  return (
    <ul>
      <li>Start: {new Date(start).toISOString()}</li>
      <li>End: {end.toISOString()}</li>
      <li>Difference: {difference}</li>
      <li>Formatted: {formatDifference(difference)}</li>
    </ul>
  );
};

export default Timer;
